import styled from "styled-components";

const TitleContainer = styled.div<{ flex?: number }>`
  display: flex;
  flex: ${props => props.flex ?? 1};
  gap: 10px;
`;

export default TitleContainer;
